// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__eV_sA","colMaxWidth":"Table_colMaxWidth__1uQqi"};